import React, {Component} from 'react'
import styled, { css } from 'styled-components'
import { media } from '../../styles/utils'

import { ribbon } from '../../styles/colors'
import { button, bgIcon } from '../../styles/global';

import arrow from '../../assets/icons/arrow-fwd.svg'
import spinner from '../../assets/icons/spinner.png'

class Submit extends Component {


    render() {
        return (
            <Wrapper>
                <Arrow
                    className={this.props.className}
                    onClick={this.props.handleSubmit}     
                    processing={this.props.processing} 
                >
                    {this.props.label}
                </Arrow>
            </Wrapper>
        )
    }
}

const Wrapper = styled.div`
    text-align: center;
    padding: 0 20px;
    background: white;
    height: 52px;
`
const Arrow = styled.div`
    background-image: url(${arrow});
    width: 11px;
    height: 18px;
    ${bgIcon}
    cursor: pointer;
    padding-top: 34px;


    ${props => {
        if (props.processing) {
            return css`
                background-image: url(${spinner});
                width: 20px;
                height: 20px;
                animation: rotate 1s linear infinite;
                @keyframes rotate {
                    0% {
                        transform: rotate(0deg)
                    }
                    100% {
                        transform: rotate(360deg)
                    }
                }
            `
        }
    }}
`

export default Submit;



// WEBPACK FOOTER //
// ./src/components/Submit/Submit.js